import { render, staticRenderFns } from "./layout_verification.vue?vue&type=template&id=0f72eb23"
import script from "./layout_verification.vue?vue&type=script&lang=js"
export * from "./layout_verification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports